/**
 * File subnav.js.
 *
 * Handles toggling the subnav menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
 ( function( $ ) {
    var subnav_toggle = $('.submenu-toggle');
    if ( subnav_toggle.length ) {
        subnav_toggle.on('click', function() {
            var subnavigation = $(this).parent().find('ul');
            subnavigation.toggleClass('toggled');
            $(this).toggleClass('open');
        });
    }
} )( window.jQuery );